import { faImage } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type ImageRendererProps = {
    src: string;
    alt: string;
    onClick?: () => void;
};

export default function ImageRenderer({ src, alt, onClick }: ImageRendererProps) {

    if (!src) {
        return <div className='min-w-[50px] min-h-[50px] max-w-[50px] max-h-[50px] bg-gray-200 rounded-lg flex items-center justify-center' >
            <FontAwesomeIcon icon={faImage} size='2xl' className='text-gray-400' />
        </div>;
    }

    return (
        <img
            className='min-w-[50px] min-h-[50px] max-w-[50px] max-h-[50px] object-cover rounded-lg cursor-pointer bg-gray-50'
            src={src}
            alt={alt}
            onClick={e => {
                if (onClick) {
                    e.stopPropagation();
                    onClick();
                }
            }}
        />
    );
}
